/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';

const style: ouiStyle.InStyle = {
  display: ouiStyle.Constants.DisplayProp.flex,
  paddingVertical: 'half',
};

export const LinkedBondDetailLineContainer = (props: React.PropsWithChildren<{
  withoutBorder?: boolean,
}>) => {
  const {
    withoutBorder = false,
    children,
  } = props;
  const css = React.useMemo(() => ouiStyle.makeCss({
    ...style,
    ...(withoutBorder === false
      ? {
        borderBottomColor: ouiStyle.Constants.Colors.inverted,
        borderBottomStyle: 'solid',
        borderBottomWidth: 'triple',
      }
      : {}
    ),
  }), [withoutBorder]);
  return (
    <div
      css={css}
    >
      {children}
    </div>
  );
};
